type StatusTone =
  | "amber"
  | "sky"
  | "violet"
  | "indigo"
  | "emerald"
  | "red"
  | "neutral";

const toneClasses: Record<StatusTone, string> = {
  amber: "bg-amber-50 text-amber-700 ring-amber-600/20",
  sky: "bg-sky-50 text-sky-700 ring-sky-600/20",
  violet: "bg-violet-50 text-violet-700 ring-violet-600/20",
  indigo: "bg-indigo-50 text-indigo-700 ring-indigo-600/20",
  emerald: "bg-emerald-50 text-emerald-700 ring-emerald-600/20",
  red: "bg-red-50 text-red-700 ring-red-600/20",
  neutral: "bg-stone-100 text-stone-600 ring-stone-500/20",
};

const statusTones: Record<string, StatusTone> = {
  pending: "amber",
  partial: "amber",
  unpaid: "amber",
  low_stock: "amber",
  confirmed: "sky",
  sent: "sky",
  processing: "violet",
  shipped: "indigo",
  delivered: "emerald",
  completed: "emerald",
  paid: "emerald",
  active: "emerald",
  success: "emerald",
  in_stock: "emerald",
  cancelled: "red",
  canceled: "red",
  failed: "red",
  overdue: "red",
  out_of_stock: "red",
  refunded: "neutral",
  draft: "neutral",
  archived: "neutral",
  no_show: "neutral",
  inactive: "neutral",
};

/** Badge classes for any order, payment, invoice, booking, or slot status. */
export function statusBadgeClass(status?: string | null): string {
  const key = (status ?? "").toLowerCase().replace(/[\s-]+/g, "_");
  const tone = statusTones[key] ?? "neutral";
  return `capitalize border-transparent ring-1 ring-inset font-semibold ${toneClasses[tone]}`;
}

export function formatStatusLabel(status?: string | null): string {
  return (status ?? "").replace(/[_-]+/g, " ");
}
